/** FR-310: the closed set of sign-in refusal page codes. Separate from the FR-077 reasons (C-305). */
export const SIGN_IN_REFUSALS = ['no_access', 'account_inactive', 'account_conflict', 'sign_in_failed'];
export const SIGN_IN_REFUSAL_SENTENCE = {
    no_access: 'Your account has no access to PresentationBuilder. Ask your administrator for access.',
    account_inactive: 'Your PresentationBuilder account is deactivated. Ask your administrator.',
    account_conflict: 'Your account cannot be matched to a PresentationBuilder user. Ask your administrator.',
    sign_in_failed: 'Signing in did not complete. Please try again.',
};
/** The status of each refusal on the MCP path (FR-310); the web path always redirects. */
export const SIGN_IN_REFUSAL_STATUS = {
    no_access: 403,
    account_inactive: 403,
    account_conflict: 403,
    sign_in_failed: 400,
};
export function isSignInRefusal(value) {
    return typeof value === 'string' && SIGN_IN_REFUSALS.includes(value);
}
//# sourceMappingURL=sign-in.js.map